module.exports = __webpack_public_path__ + "static/Others-c642ff05b0d3cc567008881a04bfd99c.png";